export default __webpack_public_path__ + "static/bg_music-85fb37db9cfd28d0e63c1ce425eebbb5.mp3";